var render = function render(){var _vm=this,_c=_vm._self._c;return _c('extra-table',{attrs:{"title":_vm.$t('addresses'),"entity":"addresses","fields":_vm.fields,"search":""},scopedSlots:_vm._u([{key:"editForm",fn:function(props){return [_c('extra-address',{attrs:{"address":props.item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }